import { useMemo } from 'react'
import { GetFormat, useGet } from 'sharedKernel/api'

export const useGetProgram = (challengeId?: string) => {
  const request = useMemo<GetFormat>(() => ({
    url: `/v1/hub/company/challenge/${challengeId ?? ''}`
  }), [challengeId])

  const { data, isLoading, isFetching, isSuccess, isError, error, refetch } = useGet<any>(
    request,
    `challenge-${challengeId}`,
    { enabled: !!challengeId }
  )
  return { data, isLoading, isFetching, isSuccess, isError, error, refetch }
}

export default useGetProgram
